export const GenerateUsername = (email) => {
  const adjectives = [
    'Alluring',
    'Seductive',
    'Handsome',
    'Irresistible',
    'Charming',
    'Attractive',
    'Captivating',
    'Magnetic',
    'Striking',
    'Dashing',
    'Hot',
    'Strong',
    'Awesome',
    'Big',
    'Muscle',
    'Sexy',
    'Gorgeous',
    'Sizzling',
    'Stunning',
    'Hunky',
    'Suave',
    'Masculine',
    'Fit',
    'Stylish',
    'Sophisticated',
    'Enchanting',
    'Desirable',
    'Exquisite',
    'Confident',
    'Alluring',
    'Dreamy',
  ];
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const localPart = email.split('@')[0];

  const res = localPart.split('.')[0].charAt(0).toUpperCase() + localPart.split('.')[0].slice(1);
  const string = `${adjective}${res}`;

  const username = string.length > 16 ? string.substring(0, 16) : string;

  return username;
};
